import React, { useState, useEffect } from 'react';

function Header () {

  return (
    
        <nav className="navbar navbar-expand-lg navbar-dark navbar-custom top-nav-collapse">
            <link href="assets/css/styles.css" rel="stylesheet"></link>
          <a className="navbar-brand logo-image" href="https://getbound.ai/">
            <img src={process.env.PUBLIC_URL + 'assets/images/logo.png'} alt="alternative" />
           </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-awesome fas fa-bars"></span>
              <span className="navbar-toggler-awesome fas fa-times"></span>
          </button>
       
          <div class="collapse navbar-collapse" id="navbarsExampleDefault">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <a class="nav-link page-scroll" href="https://getbound.ai/">Home <span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link page-scroll" href="https://getbound.ai/#services">Services</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link page-scroll" href="https://getbound.ai/#pricing">Pricing</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link page-scroll" href="https://getbound.ai/#request">Contact</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link page-scroll" href="https://dashboard.getbound.ai/">Login</a>
                </li>
            </ul>
            <span class="nav-item social-icons">
                <span class="fa-stack">
                    <a href="https://twitter.com/getboundai">
                        <i class="fas fa-circle fa-stack-2x twitter"></i>
                        <i class="fab fa-twitter fa-stack-1x"></i>
                    </a>
                </span>
                <span class="fa-stack">
                    <a href="https://www.facebook.com/Bound-107227428757946">
                        <i class="fas fa-circle fa-stack-2x facebook"></i>
                        <i class="fab fa-facebook-f fa-stack-1x"></i>
                    </a>
                </span>
                <span class="fa-stack">
                    <a href="https://www.linkedin.com/company/getbound/">
                        <i class="fas fa-circle fa-stack-2x facebook"></i>
                        <i class="fab fa-linkedin-in fa-stack-1x"></i>
                    </a>
                </span>
                
            </span>
        </div>
    </nav>
    )
}


export default Header;
